import * as React from 'react';
import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
const CustomLink = styled(Link) `
	text-decoration: inherit;
	color: inherit;
	display: block;
	padding: ${({ padding }) => padding || '0'};
	margin: ${({ margin }) => margin || '0'};
`;
/**
 * Add a description for your component here
 */
export const WithLink = ({ to, children, padding, margin, className, style, }) => {
    const history = useHistory();
    if (to && history)
        return (React.createElement(CustomLink, { padding: padding, margin: margin, to: to, style: style, className: className }, children));
    return React.createElement(React.Fragment, null, children);
};
WithLink.defaultProps = {};
export default WithLink;
